<template>
    <div class="update-nickname">
        <form @submit.prevent="updateNickName">
            <div class="row">
                <custom-input 
                    :title="$t('ACCOUNT_CARDS__USERNAME')"
                    v-model="updatedNickName"
                    :isRequired=true
                    @clear="updatedNickName = ''"
                />
                <button class="btn">Save</button>
            </div>
        </form>
        <custom-snackbar
            :text="message.text"
            :purpose="message.purpose"
            v-if="message.visible"
            @close="message.visible = false"
        ></custom-snackbar>
    </div>
</template>

<script>
import CustomInput from '@/components/ReusableComponents/CustomInput/CustomInput.vue'
import axios from '@/Helpers/AxiosInstance.js'
export default {
    components: {
        CustomInput,
    },
    props: {
        cardID: Number,
        nickName: String, 
    },
    created() {
        this.updatedNickName = this.nickName || ''
    },
    data() {
        return {
            updatedNickName: '',
            message: {
                visible: false,
                text: '',
                purpose: 'error',
            },
        }
    },
    watch: {
        nickName(val) {
            this.updatedNickName = val
        }
    },
    methods: {
        updateNickName() {
            axios
                .post('WebShop/UpdateAccountCardNickName', {
                    AccountCardId: this.cardID,
                    UserName: this.updatedNickName,
                })
                .then(resp => {
                    if (resp.data.status == 1) {
                        this.$emit('showMessage', {
                            purpose: 'success',
                            text: 'Successfully Updated Nickname!',
                        })
                        this.$emit('update')
                    } else {
                        this.showError(resp.data.status)
                    }
                })
                .catch(() => this.showError())
        },
        showError(status) {
            var text = 'An Error Occurred While Saving!'
            var code = this.statusCodes.filter(e => e.key == status)[0]
            if (code) text = this.$t('STATUS-CODE__' + code.value)
            this.$emit('showMessage', {
                purpose: 'error',
                text: text,
            })
        },
    },
    computed: {
        statusCodes() {
            return this.$store.state.statusCodes
        },
    }
}
</script>

<style lang="scss" scoped>
form {
    margin-top: 6.25rem;
}

button {
    margin-left: 15 * $rem;
}
</style>